import { t } from 'i18next';
import { Group, Text } from '@mantine/core';
import { Column } from 'utils/models';
import { formatDate } from 'utils/dates';
import { LogsList, MedicalEventType } from 'models/patientMedicalEvent';
import { DeleteLogActionIcon } from '../DeleteLogActionIcon';
import { LogDetailsActionIcon } from '../LogDetailsActionIcon';

const renderTypeColumn = (item: LogsList) => {
  switch (item?.data.type) {
    case MedicalEventType.Treatment:
      return t(`add_log_form_${item.data.treatment?.method}`);
    case MedicalEventType.DiagnosticResult:
      return t(`add_log_form_${item.data.diagnosis?.method}`);
    default:
      return t('unknown_label');
  }
};

export const LogsOverviewColumns = (): Column<LogsList>[] => {
  const columns: Column<LogsList>[] = [
    {
      header: t('type_label'),
      width: 25,
      renderItem: (item) => <Text>{renderTypeColumn(item)}</Text>,
    },
    {
      header: t('timestamp_label'),
      width: 25,
      renderItem: (item) => formatDate({ timestamp: item?.data.loggedTimestamp, formatWithTime: true }),
    },
    {
      header: t('note_label'),
      width: 35,
      renderItem: (item) => (
        <Text
          style={{
            wordBreak: 'break-all',
          }}
        >
          {item?.data.comment}
        </Text>
      ),
    },
    {
      header: t('table_actions'),
      width: 15,
      renderItem: (item) => (
        <Group gap={'xs'}>
          <LogDetailsActionIcon log={item} />
          <DeleteLogActionIcon logId={item.id} />
        </Group>
      ),
    },
  ];

  return columns;
};
